/**
 * Mapboxアクセストークンとスタイルの集約。
 * 環境変数が未設定の場合はsentinelトークンを返し、UIで警告を出せるようにする。
 */

const DEFAULT_STYLE = 'mapbox://styles/mapbox/light-v11';

export const MAPBOX_TOKEN: string =
  import.meta.env.VITE_MAPBOX_PUBLIC_TOKEN ?? '';

export const MAPBOX_STYLE_URL: string =
  import.meta.env.VITE_MAPBOX_STYLE_URL || DEFAULT_STYLE;

export function isMapboxTokenConfigured(): boolean {
  return MAPBOX_TOKEN.startsWith('pk.');
}
